<template>
    <section class="row">
        <div v-if="$store.getters.isLoading" class="loading-box col-md-12">
            <div class="spinner"></div>
            <div class="title">Loading...</div>
            <div class="text" v-if="$store.getters.loadingMsg">
                {{ $store.getters.loadingMsg }}
            </div>
        </div>
        <div v-if="savedApplications.length > 0 && !$store.getters.isLoading" class="row ml-0 col-md-12">
            <b-card-group v-for="(item,index) in savedApplications.slice((currentPage-1)*perPage,(currentPage-1)*perPage+perPage)" :key=index  class="col-md-4 mt-3" style="border: solid 0px blue;">
                <b-card  v-bind:class="['px-0 mx-0', { 'card card-AppSubmitted': item.IsSubmitted || item.Step == 7,'card card-AppProgress': !item.IsSubmitted }]"><!-- class="px-0 mx-2 ml-2" style="margin-left:5px !important; width: 270px !important;"-->
                    <div class="card mx-auto" style="">
                    <div class="card-body p-0 col-md-12" style="border: solid 0px red"><!-- style="border: solid 1px red"-->
                        <div class="card-header mt-0 px-2 pt-1">
                            <!--<div class="savedApp" @click= "OpenSavedApp(index)">
                                <div class="savedApp" style="cursor: pointer;" v-on="!item.IsSubmitted ? { click: () => OpenSavedApp(index) } : {click: ($event) => $event.preventDefault() }"> -->
                                <div class="savedApp"><!-- @click= "OpenSavedApp(index)"-->
                                <b>{{item.ProductionTitle}}</b> &nbsp;<sup><b-badge v-if ="item.IsCopied" variant="secondary">Copy</b-badge></sup><br/>
                                <div class="row savedApp_SmallFont">
                                    <div class="col-md-5 col-xs-12 text-left ">
                                        <span class="text-nowrap">Shoot start date:&nbsp;</span>
                                        <span class="text-nowrap">{{ FormatDate (item.FilmingStartDate) }}</span>
                                    </div>
                                    <div class="col-md-7 col-xs-12">
                                        <div v-if="item.CityGrid.trim() =='grid'">
                                            Grid (city all) permit application
                                        </div>
                                        <div v-else>
                                            <span v-if="item.FilmLocation !='' && item.FilmLocation !=null">
                                                
                                                <span class="text-nowrap">Filming location:&nbsp;</span>
                                                <span class="text-nowrap">
                                                {{ Truncate (item.FilmLocation,22) }} 
                                                <i v-if="item.FilmLocation.length > 22" class="fas fa-info-circle" v-b-popover.hover.top="item.FilmLocation"></i>
                                                </span>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                    
                            </div>
                        </div>
                        <div class="savedApp card-body col-md-12 pr-0"><!-- style="border: solid 0px blue;"-->
                        <b-card-text>
                            <div class="row col-md-12  col-sm-12 col-xs-12">
                                <div class="col-md-4 col-sm-4 col-xs-4 text-center" style="border:solid 0px red">
                                    <div class="mt-4" v-if="item.Step >= 7 && item.IsSubmitted">
                                        <i class="fas fa-check" style="font-size:20px"></i>
                                    </div>
                                    <div v-else>
                                        <CircularProgress
                                            :completedPercent="CalculatePercentage(item.Step, item.CityGrid)"
                                            class="circular"
                                            :label=index.toString()
                                            />
                                            <!--:label="String(item.Step)"-->
                                    </div>
                                </div>
                                <div class="col-md-8 col-sm-8 col-xs-8 savedApp_SmallFont lighterFont text-nowrap pt-2 pb-2"  style="border:solid 0px blue">
                                    <span v-if="item.Step >= 7 && item.IsSubmitted">
                                        Film permit application<br/>
                                        Submitted on  {{ FormatDate (item.DateOfCreation) }} <br/>
                                        Reference number: {{ item.PermitId}}
                                    </span>
                                    <span v-else v-html="ReWriteStep(item.Step, item.CityGrid)"></span>
                                </div>
                            </div>
                        </b-card-text>
                        </div>
                        <div class="card-footer align-middle" style="padding-bottom:32px"><!--height:40px;--><!--d-flex align-items-center justify-content-center-->
                            <a v-if="!item.IsSubmitted" class="card-bottom-menu float-left mr-3" @click="OpenSavedApp(index)">Edit</a> 
                            <span class="float-left" v-if="item.Step >= 7 && item.IsSubmitted">
                                <!--<a id="show-btn" class="text-primary" v-b-modal="'CopyConfirmModal_' + savedApplicationsType + '_' + index">Copy</a>&nbsp;<i class="far fa-question-circle text-primary" v-b-popover.hover.top="'Begin a new application using this one as the starting point.'" ></i>-->
                                <!--TODO: <a id="show-btn" class="card-bottom-menu" v-b-modal="'CopyConfirmModal_' + savedApplicationsType + '_' + index">Copy</a>&nbsp;<i class="far fa-question-circle" style="color: #00629B" v-b-popover.hover.top="{ variant: 'info',  content: 'Begin a new application using this one as the starting point.'}" ></i>-->
                                <b-modal 
                                    :id="'CopyConfirmModal_' + savedApplicationsType + '_' + index" 
                                    ref="CopyModal" 
                                    hide-footer
                                    @show="resetModal"
                                    @hidden="resetModal"
                                    @ok="ProcessCopy(index)"
                                ><!--handleOk-->
                                    <div @click="$bvModal.hide('CopyConfirmModal_' + savedApplicationsType + '_' + index)" style="float:right;margin-top:-60px; padding-right: 20px; cursor:pointer;">Close</div>
                                    <template #modal-title>
                                        Copy this application?
                                    </template>
                                    <div class="d-block text-left">
                                        Are you sure that you want to copy this application?
                                    </div>
                                    <div class="float-left mt-3"> 
                                        <b-button @click="ProcessCopy(index)" class="btn btn-primary">Yes</b-button> 
                                        <b-button @click="CancelCopy(index)" class="btn btn-reject ml-3">No</b-button>
                                    </div>
                                    
                                </b-modal>
                            </span>

                            <!--BKup: <span class="linkCursor" style="float:right;" @click="DeActivateSavedApp(item.Id)"><i class="far fa-trash-alt"></i></span>-->
                            <span style="float:right;">
                                <a  id="show-btn" class="card-bottom-menu" v-b-modal="'DeleteConfirmModal_' + item.Id">Delete</a>
                                <b-modal 
                                    :id="'DeleteConfirmModal_' + item.Id" 
                                    ref="DeleteModal" 
                                    hide-footer
                                    @show="resetModal"
                                    @hidden="resetModal"
                                    @ok="ProcessDelete({id:item.Id,step:item.Step,stamp:item.DateOfCreation})" 
                                ><!--Bkup: @ok="ProcessDelete(item.Id)"--><!--@ok="ProcessDelete({id:item.Id,step:item.Step,stamp:item.DateOfCreation})"-->
                                    <div @click="$bvModal.hide('DeleteConfirmModal_' + item.Id)" style="float:right;margin-top:-60px; padding-right: 20px; cursor:pointer;">Close</div>
                                    <template #modal-title>
                                        Delete this application?
                                    </template>

                                    <div class="d-block text-left">
                                        You won't be able to retrieve it once you delete it.
                                    </div>
                                    <div class="float-left mt-3"> 
                                        <b-button @click="CancelDelete(item.Id)" class="btn btn-reject">Cancel</b-button>
                                        <b-button @click="ProcessDelete({id:item.Id,step:item.Step,stamp:item.DateOfCreation})" class="btn btn-primary ml-3">Yes, delete it</b-button>
                                        <!--Bkup:<b-button @click="ProcessDelete(item.Id)" class="btn btn-primary ml-3">Yes, delete it</b-button>-->
                                        <!--<b-button class="mt-3" block @click="$bvModal.hide('modal-SaveApp')">Close Me</b-button>-->
                                    </div>
                                </b-modal>
                            </span>

                        </div>
                    </div>
                    </div>
                    
                </b-card>
            </b-card-group>
            
            <div class="col-md-12 mt-4">
                <div class="col-lg-6 offset-lg-3 col-md-6 offset-md-3 col-sm-12 text-center">
                    <span v-if="perPage < savedApplications.length" style="margin-right:10px"><button @click="perPage += showMore" class="btn-ShowMore btn">show more</button></span>
                    <span  v-if="perPage > showMore"><button @click="perPage -= showMore" class="btn btn-ShowLess">show less</button></span>
                </div>
            </div>
            <!--
            <div class="col-md-12 mt-4" style="border: solid 1px blue;">
                    <div class="row justify-content-sm-center" style="border: solid 1px red; text-align:center;">
                    <span v-if="perPage < savedApplications.length"><button @click="perPage += showMore" class="btn btn-ShowMore ">show more</button></span>
                    <span v-if="perPage > showMore" style="margin-left:10px"><button @click="perPage -= showMore" class="btn btn-ShowLess">show less</button></span>
                </div>
            </div>
            -->
        </div>  
        <!--<div @scroll="onScroll" id="bottomDiv" ref="bottomDiv" style="height: 22px;width:2px; border: solid 0px red !important;"></div>-->
    </section>
</template>

<script>
import CircularProgress from "@/components/PagesRelated/CircularProgress";
import moment from 'moment';

export default{
    name:'SavedApplicationsDisplay',
    components: {
        CircularProgress,
    },
    data() {
        return {
            showMore: 9,
            perPage: 9,
            currentPage: 1,
            percentage: "0",
            appTotalSteps:6,
        }
    },
    props: {
        savedApplications: {
            type: Array,
            required: true
        },
        savedApplicationsType: {
            type: String,
            default: ''
        },
    },
    methods:{
        FormatDate(date) {
            return new Intl.DateTimeFormat('en-US', { dateStyle: 'medium' }).format(new Date(date))  //with time - just add: , timeStyle: 'short'
        },
        FormatDate2(date) {    
            /*
            var m = moment(new Date(date));
            return m.format('LL');
            var options = { year: 'numeric', month: 'long', day: 'numeric' }; //weekday: 'long', 
            var savedDate  = new Date(date);
            //return savedDate.toLocaleDateString("en-US", options);
            //return savedDate.toLocaleDateString('en-US').replace(/[^ -~]/g,'');
            */
            var filmStartDate = (new Date(date)).toISOString();
            //return filmStartDate;
            //return new Intl.DateTimeFormat('en-US', { dateStyle: 'medium' }).format(new Date(filmStartDate));
            return date;
        },
        OpenSavedApp(appIndex)
        {
            //this.$emit("GoToApp",appIndex);   
            this.$emit("GoToApp",{appIndex: appIndex,appType: this.savedApplicationsType});
        },
        CalculatePercentage(step,permitType)
        {
            var totalSteps = 6;
            var savedStep = step;
            if(permitType.trim()=='grid')
            {
                totalSteps = 4;
                savedStep = (step >= (this.appTotalSteps + 1)) ? totalSteps : step;
            }  
            if(permitType.trim()=='permit')
            {
                totalSteps = 6;
                savedStep = (step >= (this.appTotalSteps + 1)) ? totalSteps : step;
            }
                
            let percentage = Math.round((Number(savedStep)/totalSteps)*100);
            return percentage;
        },
        ReWriteStep(step,permitType)
        {
            var msg="Film permit application <br/>in progress ";
            if(permitType.trim()=='grid')
                return (step >= 7) ? msg + '4 of 4 sections <br>completed.' : msg + step + ' of 4 sections <br>completed.';
            else
                return (step >= 7) ? msg + '6 of 6 sections <br>completed.' : msg + step + ' of 6 sections <br>completed.';
        },
        CancelCopy(id) {
            this.$root.$emit('bv::hide::modal', 'CopyConfirmModal_' + this.savedApplicationsType + '_' + id, '#CopyModal')

            //display alert msg.
            this.$emit('displayAlertMsg',{displayStatus:true, msg:'Copy application is canceled.', alertType:'info', timeOut: 5000}); 
        },
        ProcessCopy(id) {            
            if (!this.CheckFormValidity()) 
                return;

            // Trigger submit handler
            this.$emit("CopyApplication",{appIndex: id,appType: this.savedApplicationsType});

            // Hide the modal manually
            this.$nextTick(() => {
                this.$bvModal.hide('CopyConfirmModal_' + this.savedApplicationsType + '_' + id)
                
                //determine if the "copy" happens in the "submitted" applications tab
                //then after copy event/process is done 
                //to switch to "Saved" tab for display
                if(this.savedApplications[0].Step >= this.appTotalSteps + 1)
                {
                    this.$emit('switchTab',0);
                    this.$emit('displayAlertMsg',{displayStatus:true, msg:'Your copy request is completed.', alertType:'info', timeOut: 5000});
                }
            })           

            //display alert msg.
            //this.$emit('displayAlertMsg',{displayStatus:true, msg:'The application is copied.', alertType:'info', timeOut: 5000});
        },
        CheckFormValidity() {
            //const valid = this.$refs.form.CheckValidity()
            //this.nameState = valid

            /*IF NEEDED: TO IMPLEMENT*/
            const valid = true;
            return valid
        },
        CancelDelete(id) {
            //this.$root.$emit('bv::hide::modal', 'DeleteConfirmModal_' + id, '#DeleteModal_' + id)
            // Hide the modal manually
            this.$nextTick(() => { this.$bvModal.hide('DeleteConfirmModal_' + id) })
        },
  
        ProcessDelete(obj) {
            // Prevent modal from closing
            //bvModalEvt.preventDefault()

            // Trigger submit handler
            this.$emit("DeActivateSavedApp",obj);
            //this.$emit("DeActivateSavedApp",{Id: id,Step: 2,Stamp:'abcxyz'});
            //this.$emit("DeActivateSavedApp",{Id: id,Step: step,Stamp:stamp});

            // Hide the modal manually
            this.$nextTick(() => {
                this.$bvModal.hide('DeleteConfirmModal_' + obj.id);
                //this.$emit('displayAlertMsg',{displayStatus:true, msg:'The saved application is deleted.', alertType:'warning', timeOut: 5000});
            })

        },
        /* Bkup
        ProcessDelete(id) {
            // Prevent modal from closing
            //bvModalEvt.preventDefault()

            // Trigger submit handler
            this.$emit("DeActivateSavedApp",id);

            // Hide the modal manually
            this.$nextTick(() => {
                this.$bvModal.hide('DeleteConfirmModal_' + id);
                //this.$emit('displayAlertMsg',{displayStatus:true, msg:'The saved application is deleted.', alertType:'warning', timeOut: 5000});
            })

        },*/
        Truncate(str, n){
            //return (str.length > n) ? str.substr(0, n-1) + ' <i class="far fa-question-circle" v-b-popover.hover.top="' + str + '" ></i>' : str;
            return (str.length > n) ? str.substr(0, n-1) + '... ' : str;
        },
        resetModal() {
            this.ApplicationName = ''
        }, 

        /*
        onScroll({ target: { scrollTop, clientHeight, scrollHeight }}) {
            alert('onScroll...');
            if (scrollTop + clientHeight >= scrollHeight) {
                //this.loadMorePosts()
                alert('scroll to the bottom');
            }
        },
        onScroll_02()
        {
            alert('in onScroll');
            const container = this.$el.querySelector("#bottomDiv");
            container.scrollTop = container.scrollHeight;
            if (container.scrollTop + container.clientHeight >= container.scrollHeight) {
                alert('bottom');
            }
        },
        onScroll () {
            window.onscroll = () => {
                //alert('windows is on scroll');
                var container = document.querySelector('#bottomDiv');
                //const container = this.$refs.bottomDiv;
                console.log(container.scrollTop + '...' + container.clientHeight + ' div height: ' + container.scrollHeight);
                if (container.scrollTop + container.clientHeight >= container.scrollHeight) {
                    console.log('bottom');
                }
            }
        }
        */
    },
};
</script>


